import { createTheme } from "@mui/material";
import "@fontsource/be-vietnam";
import { grey } from "@mui/material/colors";
export const theme = createTheme({
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "::-webkit-scrollbar": {
          width: "6px",
          height: "6px",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.35)",
          borderRadius: "8px",
        },
        "::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "rgba(0,0,0,0.55)",
        },
        "::-webkit-scrollbar-track": {
          background: "transparent",
        },
        /* Firefox */
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(0,0,0,0.35) transparent",
        },
        body: {
          color: "#000 !important",
        },
      },
    },
  },
  palette: {
    mode: "light",
    divider: grey[400],
    text: {
      primary: grey[900],
      secondary: grey[800],
    },
    primary: {
      main: "#28282D",
      // light: "#3C478B",
    },
    warning: {
      main: "#FEDADA",
      contrastText: "#FF3333",
    },
  },
  typography: {
    fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
    h1: {
      fontSize: "40px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: "56px",
    },
    h2: {
      fontSize: "30px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: "42px",
    },
    h3: {
      fontSize: "24px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: "32px",
    },
    subtitle1: {
      fontSize: "16px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 700,
    },
    subtitle2: {
      fontSize: "14px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 500,
    },
    body1: {
      fontSize: "14px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 500,
    },
    body2: {
      fontSize: "12px",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 500,
    },
    button: {
      fontSize: "14px",
      textTransform: "none",
      fontFamily: "Be Vietnam, Montserrat, Arial, sans-serif",
      fontWeight: 700,
    },
  },
});
